import './index.scss'

export default function BuzzLogo(props: {logo?: string}) {
    return (
        <div className="buzz-logo">
            <img src={props.logo || ''} alt="" />
        </div>
    )
}